export default function Salescb() {
    
    return (
        <><iframe title="Report Section" width="1024" height="1060" src={process.env.REACT_APP_SALES_CB_URL} frameborder="0" allowFullScreen="true"></iframe></>
    )
}